/* ============================================================
   Footer Signup — behavior
   Assigns a group index (--gi) to every [data-stagger-group]
   container in DOM order, and within each group an item index
   (--ii) to its [data-stagger-item] children. Toggles
   data-in-view on the footer every time it enters/exits the
   viewport, same replayable pattern as the CTA banner, so the
   cascade — newsletter, then each column, then social/logo/
   badges — plays again on every scroll-in.

   FIX (accordion never opened): the mobile "+" toggle button
   (data-footer-accordion-trigger) and its panel
   (data-footer-accordion-panel) were both in the markup, and the
   CSS already had a max-height transition ready for an
   `.is-open` class — but nothing in this file ever attached a
   click handler to the trigger, so tapping "+" did nothing at
   all. Added initAccordions() below: it toggles `.is-open` on
   the column, flips aria-expanded for accessibility, and sets
   panel.style.maxHeight to the panel's real scrollHeight (CSS
   `max-height` transitions need an actual pixel value to animate
   to — "none"/"auto" doesn't transition) when opening, and back
   to 0 when closing. A resize listener keeps an already-open
   panel's height correct (e.g. rotating a phone).
   ============================================================ */
(function () {
  'use strict';

  function initFooter(footer) {
    if (footer.dataset.footerInitialized === 'true') return;
    footer.dataset.footerInitialized = 'true';

    var groups = Array.prototype.slice.call(footer.querySelectorAll('[data-stagger-group]'));
    groups.forEach(function (group, groupIndex) {
      var items = Array.prototype.slice.call(group.querySelectorAll('[data-stagger-item]'));
      items.forEach(function (item, itemIndex) {
        item.style.setProperty('--gi', groupIndex);
        item.style.setProperty('--ii', itemIndex);
      });
    });

    if (footer.dataset.stagger === 'true' && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  footer.setAttribute('data-in-view', 'true');
                });
              });
            } else {
              footer.removeAttribute('data-in-view');
            }
          });
        },
        { threshold: 0.15 }
      );

      observer.observe(footer);
    } else {
      /* Stagger disabled, or no IntersectionObserver support —
         make sure content is simply visible rather than stuck
         hidden. */
      footer.setAttribute('data-in-view', 'true');
    }

    initAccordions(footer);
  }

  /* ---------- Mobile link-column accordion ---------- */
  function initAccordions(footer) {
    var columns = Array.prototype.slice.call(footer.querySelectorAll('[data-footer-accordion]'));

    columns.forEach(function (column) {
      var trigger = column.querySelector('[data-footer-accordion-trigger]');
      var panel = column.querySelector('[data-footer-accordion-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = column.classList.contains('is-open');

        if (isOpen) {
          column.classList.remove('is-open');
          panel.style.maxHeight = '0px';
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          column.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* Keep an open panel's max-height correct if the window is
       resized (rotating a phone, or a live theme-editor resize)
       while it's expanded — otherwise a stale pixel value could
       clip newly-wrapped link text. */
    window.addEventListener('resize', function () {
      footer.querySelectorAll('[data-footer-accordion].is-open [data-footer-accordion-panel]').forEach(function (panel) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-site-footer]').forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor support: re-init when the section is added/reloaded.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();